import { render, staticRenderFns } from "./StaffMatrixTable.vue?vue&type=template&id=fdab0040&"
import script from "./StaffMatrixTable.vue?vue&type=script&lang=js&"
export * from "./StaffMatrixTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports